import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { useStore } from '../../../models'
import { color } from '../../../theme'
import { InfoRectangle } from '../InfoRectangle'
import { ProgressBar } from '../ProgressBar'
import { useCallback } from 'react'
import { DS } from '../../../design-system'
import { useResponsive } from '@/screens/new-design/hooks'

export const PlayerHandLastAction = observer(({ hiddenProgressBar }: { hiddenProgressBar: boolean }) => {
  const {
    game: {
      actionTime,
      playerActionTimeLeft,
      shouldShowProgressBar,
      myPlayer,
      currentPlayerId,
      setPlayerActionTimerExpired,
      myPlayerLastActionText
    }
  } = useStore()
  const { verticalScale } = useResponsive()
  const showProgressBar =
    shouldShowProgressBar && myPlayer?.id === currentPlayerId && !myPlayer?.isFolded() && !hiddenProgressBar

  const onComplete = useCallback(() => {
    setPlayerActionTimerExpired(true)
  }, [setPlayerActionTimerExpired])

  if (!showProgressBar) {
    return (
      <InfoRectangle>
        <DS.Text variant="Caption/Bold" uppercase style={{ width: '100%', textAlign: 'center' }}>
          {myPlayerLastActionText}
        </DS.Text>
      </InfoRectangle>
    )
  }

  return (
    <View style={styles.animatedContainer}>
      <View style={styles.progressBarContainer}>
        <DS.Text variant="Caption/Bold" uppercase color={'Global/White'}>
          Your turn
        </DS.Text>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', height: verticalScale(12) }}>
          <ProgressBar
            duration={playerActionTimeLeft}
            maxDuration={actionTime}
            backgroundColor={'Global/Black'}
            backgroundOpacity={0.5}
            color={'Global/White'}
            onComplete={onComplete}
          />
        </View>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  text: {
    textTransform: 'uppercase'
  },
  progressBarContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    gap: 24
  },
  animatedContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 28,
    backgroundColor: color.palette.orange,
    borderTopEndRadius: 40,
    borderBottomEndRadius: 40,
    borderTopStartRadius: 12,
    borderBottomStartRadius: 40,
    paddingVertical: 12
  }
})
